export interface MfeFailureLog {
  mfeName: string;
  errorMessage: string;
  errorType: 'open_failed' | 'unavailable' | 'callback_timeout' | 'unknown';
  component: string; // e.g. 'SendInvoiceStep' or 'ResendInvoiceDialog'
  timestamp: string;
  invoiceNumber?: string;
  instanceId?: string;
}

/**
 * Log an MFE failure to the backend for observability and alerting.
 * Fire-and-forget — failures in logging itself should never block the user.
 */
export async function logMfeFailure(entry: MfeFailureLog): Promise<void> {
  try {
    await fetch('/api/billing/mfe-failures', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(entry),
    });
  } catch {
    // Logging failure itself should never surface to the user
    console.warn('[MFE Failure Logger] Could not POST failure log', entry);
  }
}
